<template>
  <div class="widget-handler">
    <TextWidget :element="element" :config="config" v-if="widgetName=='text'"/>
    <ImageWidget :config="config" v-if="widgetName=='image'"/>
    <QrWidget :config="config" v-if="widgetName=='qr'"/>
  </div>
</template>

<script>

export default {
  name: "WidgetsHandler",
  components: {
    'TextWidget': () => import('./Widgets/Text/Text'),
    'ImageWidget': () => import('./Widgets/Image/Image'),
    'QrWidget': () => import('./Widgets/Qr/Qr'),
  },
  props: {
    widgetName: {},
    config:{},
    element: {}
  }
}
</script>

<style scoped>
.widget-handler {
  width: 100%;
  height: 100%;
}
</style>
